import React, { Component } from "react";
import "./../../../assests/styles/CreditLinesBodyStyle.css";
import CircularProgress from '@material-ui/core/CircularProgress';

const datefor = new Intl.DateTimeFormat("en-GB", {
	year: "numeric",
	month: "short",
	day: "2-digit",
	hour: "2-digit",
	minute: "2-digit",
	timeZone: "Asia/Kolkata",
	hour12: true
});

const datefor2 = new Intl.DateTimeFormat("en-GB", {
	year: "numeric",
	month: "short",
	day: "2-digit",
	timeZone: "Asia/Kolkata",
	hour12: true
});

var user = JSON.parse(localStorage.getItem("user"));

export default class CreditLineItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showDetails: false,
			copySuccess: "",
			open: false,
			sourceProductName: null,
			destinationProductName: null,
			sourceCreditLineId: null,
			destinationCreditLineId: null,
			bzId: null
		};
		this.creditLineStatusTransitionBoList = this.creditLineStatusTransitionBoList.bind(this);
		this.myRef = React.createRef();
		this.copyToClipboard = this.copyToClipboard.bind(this);
	}



	render() {
		var data = this.props.data;
		return (
			<div className="CreditLineItem">
				<div onClick={() => this.setState({ showDetails: !this.state.showDetails })}>
					<div className="row">
						<div className="col-md-4">
							<div className="row">
								<div className="col-md-7">{this.firstCol()}</div>
								<div className="col-md-5">{this.secondCol()}</div>
							</div>
						</div>
						<div className="col-md-3">{this.thirdCol()}</div>
						<div className="col-md-3">{this.fourthCol()}</div>
						<div className="col-md-2">{this.fifthCol()}</div>
					</div>
					<div style={{ padding: "inherit" }}> {data.blockReason ? this.showBlockReason() : null} </div>
				</div>
				<div> {this.state.showDetails ? this.showDetailsOfLine() : null} </div>
				<div> {this.state.showDetails ? this.showDetailsOfCreditItemLine2() : null} </div>
				<div> {this.state.showDetails ? this.creditLineStatusTransitionBoList() : null} </div>
				<div> {this.state.showDetails ? this.showMoveToButton() : null} </div>
			</div>
		);
	}

	showCircularLoading() {
		return (
			<CircularProgress size={21} />
		);
	}

	showMoveToButton() {
		var data = this.props.data;
		let restrictmailids = JSON.parse(localStorage.getItem("user"));
		let jumbotailUser = restrictmailids.userProfile.loginId.split('@');
		let tenant_Id = restrictmailids.userProfile.tenantId;
		return (
			<div className="row">
				<div className="black" style={{ float: "right", padding: "1em 1em 0em 0em" }}>
					{/*Commenting merge
						<button onClick={() => this.props.handleClickOpen(data)} className="btn btn-jt-ops-inverted pull-right">
						Merge into
					</button>*/}
					<div className="inline" style={{ padding: "10px 6px 0px 6px" }}>
						&nbsp;
						{this.props.showCircularLoading ? this.showCircularLoading() : null}
						&nbsp;
					</div>

					{
						tenant_Id == "TENANT-135108" && jumbotailUser[1] != 'jumbotail.com'
						?
						" "
						:

						(
							this.showUpdateButton(data)
						)
					}

				</div>
			</div>
		);
	}

	showUpdateButton(data) {
		return (
		<button onClick={() => this.props.handleClickUpdateFromLineItems(data.naturalId, data.creditLineStatus)} className="btn btn-jt-ops-inverted pull-right" style={{ marginRight: "1em" }}>
			Update
		</button>
		);
	}

	creditLineStatusTransitionBoList() {
		let data = this.props.data.creditLineStatusTransitionBoList;
		data.sort(function (a, b) {
			return a.lastUpdatedTime < b.lastUpdatedTime ? 1 : b.lastUpdatedTime < a.lastUpdatedTime ? -1 : 0;
		});
		let showStatusTransition = data.map((card, index) => {
			return (
				<div className="innerDivForStatusTransition" key={index}>
					<div className="row">
						<div className="col-md-3">{datefor.format(card.lastUpdatedTime)}</div>
						<div className={"col-md-2 " + card.status} style={{ fontWeight: "500px" }}>
							{card.status}
						</div>
						<div className="col-md-3">{card.lastUpdatedBy}</div>
						<div className={"col-md-4 " + card.status}>{card.reason ? <div style={{ fontSize: "12px" }}>{card.reason}</div> : null}</div>
					</div>
				</div>
			);
		});
		return <div className="outerDivForStatusTransition">{showStatusTransition}</div>;
	}

	showBlockReason() {
		return (
			<div className="row">
				<div className="black" style={{ textAlign: "right", padding: "0 20px" }}>
					Blocked Reason:
					<div className="inline red">{" " + this.props.data.blockReason}</div>
				</div>
			</div>
		);
	}

	showDetailsOfCreditItemLine2() {
		var data = this.props.data;
		return (
			<div className="row" style={{ padding: "1em 0em" }}>
				<div className="col-md-2">
					<div className="lite">NACH ID:</div>
					<div>{data.nachAccountId ? data.nachAccountId : "N/A"}</div>
				</div>
				<div className="col-md-2">
					<div className="lite">Subsidized Days:</div>
					<div>{data.subsidizedDays ? data.subsidizedDays : (data.subsidizedDays == 0 ? 0 : "N/A")}</div>
				</div>
				<div className="col-md-2">
					<div className="lite">Total Limit Including Buffer:</div>
					<div>{data.finalLimitIncludingBuffer ? data.finalLimitIncludingBuffer : (data.finalLimitIncludingBuffer == 0 ? 0 : "N/A")}</div>
				</div>
				<div className="col-md-2">
					<div className="lite">Buffer Value:</div>
					<div>{data.bufferValue ? data.bufferValue : (data.bufferValue == 0 ? 0 : "N/A")}</div>
				</div>
				<div className="col-md-2">
					<div className="lite">Buffer Type:</div>
					<div>{data.bufferType ? data.bufferType : "N/A"}</div>
				</div>
			</div>
		);
	}

	showDetailsOfLine() {
		var data = this.props.data;
		return (
			<div className="row">
				<hr />
				<div className="col-md-2">
					<div className="lite">Transaction Limit:</div>
					<div>{data.overAllLimit}</div>
				</div>
				<div className="col-md-2">
					<div className="lite">Outstanding:</div>
					{this.printItemDetails(data.outstandingTransactionTotalAmount, data.outstandingTransactionsCount, "red")}
				</div>
				<div className="col-md-2">
					<div className="lite">Outstanding Bounces:</div>
					{this.printItemDetails(data.outstandingBouncedTotalAmount, data.outstandingBouncedCount, "red")}
				</div>
				<div className="col-md-2">
					<div className="lite">Total Bounces:</div>
					{this.printItemDetails(data.overallBouncedTotalAmount, data.overallBouncedCount, "black")}
				</div>
				<div className="col-md-2">
					<div className="lite">Total Transactions:</div>
					{this.printItemDetails(data.overallTransactionsTotalAmount, data.overallTransactionsCount, "green")}
				</div>
				<div className="col-md-2">
					<div className="lite">Line Start Date</div>
					<div className="black">{datefor2.format(data.creditLineStartDate)}</div>
				</div>
			</div>
		);
	}

	printItemDetails(one, two, color) {
		return (
			<div>
				<span className={color + " bold"}>₹{" " + (one === null ? " " : one) + " "}</span>
				<span className="black">in</span>
				<span className={color + " bold"}>{" " + two + " "}</span>
				<span className="black">txns</span>
			</div>
		);
	}

	copyToClipboard(e) {
		const el = document.createElement("textarea");
		el.value = this.myRef.current.firstChild.data;
		document.body.appendChild(el);
		el.select();
		document.execCommand("copy");
		document.body.removeChild(el);
		e.stopPropagation();
		return;
	}

	firstCol() {
		var data = this.props.data;
		return (
			<div className="firstCol">
				<div className="littleSpace black" ref={this.myRef}>
					{data.bzId}
					<div className="inline">
						<i className="far fa-copy" style={{ marginLeft: "5px" }} onClick={this.copyToClipboard} />
					</div>
				</div>
				<div className="littleSpace lite">{data.storeName}</div>
			</div>
		);
	}
	secondCol() {
		const data = this.props.data;
		return (
			<div className="firstCol">
				<div className="littleSpace lite">{data.userDetailsList == null ? " " : data.userDetailsList[0].firstName}</div>
				<div className="littleSpace lite">{data.userDetailsList == null ? " " : data.userDetailsList[0].mobileNumber}</div>
			</div>
		);
	}
	thirdCol() {
		var data = this.props.data;
		var interestRate = data.interestRate;

		if(interestRate === 0){
			interestRate = parseFloat((data.convenienceFeeRate + (data.convenienceFeeRate*18)/100).toFixed(4));
		}

		return (
			<div className="firstCol">
				<div className="boxStyle littleSpace">{data.creditProductName}</div>
				<div className="centerThis littleSpace">
					<span style={{ opacity: "0.5" }}>Overall Limit:&nbsp;</span>₹<span className="black">&nbsp;{data.overAllLimit}</span>
				</div>
				<div className="centerThis littleSpace">
					<span style={{ opacity: "0.5" }}>Interest Rate: &nbsp;</span> <span className="black"> &nbsp;{interestRate} % per day</span>
				</div>
			</div>
		);
	}
	fourthCol() {
		var data = this.props.data;
		return (
			<div>
				<div className="littleSpace">
					<span style={{ opacity: "0.5" }}>Remaining Limit:&nbsp;</span>
					<span className="green">₹&nbsp;{data.currentLimit}</span>
				</div>
				<div className="littleSpace">
					<span style={{ opacity: "0.5" }}>Average DPD:&nbsp;</span>
					<span className="red">{data.averageDaysPastDue} days</span>
				</div>
				<div className="littleSpace">
					<span style={{ opacity: "0.5" }}>Tenure :&nbsp;</span>
					<span className="red">{data.tenure} days</span>
				</div>
			</div>
		);
	}
	fifthCol() {
		const data = this.props.data;
		var status = this.props.data.creditLineStatus;
		let color = "";
		if (status === "ACTIVE") color = "green";
		else if (status === "ON_HOLD") color = "yellow";
		else if (status === "BLOCKED") color = "red";
		else if (status === "INACTIVE") color = "red";
		return (
			<div>
				<div className={color + "-status-box " + color} style={{ float: "right", padding: "5px" }}>
					<strong>{data.creditLineStatus}</strong>
				</div>
				<div className="littleSpace" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/creditLines/components/CreditLineItem.js